import React from 'react';
import { InputNumber } from 'antd';
import { useFormContext, Controller } from 'react-hook-form';

interface CurrencyInputProps {
  name: string;
  label: string;
  required?: boolean;
}

export default function CurrencyInput({ name, label, required }: CurrencyInputProps) {
  const { control, formState: { errors } } = useFormContext();

  const error = name.split('.').reduce((obj: any, key) => obj?.[key], errors);
  const errorMsg = error?.message as string | undefined;

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <InputNumber
            {...field}
            className="w-full"
            prefix="R$"
            decimalSeparator=","
            precision={2}
            min={0}
            status={errorMsg ? 'error' : undefined}
            formatter={(value) => value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.') : ''}
            parser={(value) => value?.replace(/[R$\s.]/g, '').replace(',', '.') as unknown as number}
          />
        )}
      />
      {errorMsg && <p className="text-red-500 text-xs mt-1">{errorMsg}</p>}
    </div>
  );
}
